import * as React from "react";
import Typography from "@mui/material/Typography";
import { CommonProps } from "@mui/material/OverridableComponent";

interface TitleProps {
  children?: React.ReactNode;
}

export default function Title(props: TitleProps & CommonProps) {
  return (
    <Typography
      className="common-title"
      component="h2"
      variant="h6"
      color="primary"
      gutterBottom
      {...props}
    >
      {props.children}
    </Typography>
  );
}
